import { connect } from 'react-redux';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import image1 from '../../assets/testJedan/Primer1RT1.png'
import image2 from '../../assets/testJedan/vezba2test1.png'
import image3 from '../../assets/testJedan/vezba3test1.png'

const Toast = Swal.mixin({
	toast: true,
	position: 'top-end',
	showConfirmButton: false,
	timer: 3000,
	timerProgressBar: true,
	didOpen: (toast) => {
		toast.addEventListener('mouseenter', Swal.stopTimer)
		toast.addEventListener('mouseleave', Swal.resumeTimer)
	}
})

const centerText = {
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
}
class introIntTestOne extends Component {
	constructor(props) {
		super(props)
		this.state = {
			P1: '',
			P2: ''
		}
		this.onChange = this.onChange.bind(this);
	}

	onChange(e) {
		this.setState({ [e.target.name]: e.target.value }, () => {
			if (e.target.name === 'P1' && e.target.value === '4') {
				Toast.fire({
					icon: 'success',
					title: 'To je tačan odgovor'
				})
			} else if (e.target.name === 'P2' && e.target.value === '3') {
				Toast.fire({
					icon: 'success',
					title: 'To je tačan odgovor'
				})
			}
		});
	}
	render() {
		return (
			<div className="Content">
				<div style={{
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					height: "inherit",
					padding: "3px"
				}}>
					<div style={{
						width: "80%",
						height: "80%",
						background: "#fff",
						boxShadow: "15px 15px 25px #ccc",
						borderRadius: "15px"
					}}>
						<div style={{ textAlign: "center", margin: "24px 50px 12px" }}>
							<div style={{ padding: "16px 0", textAlign: "left" }}>
								<br /><br />
								<div style={centerText}>Zdravo {this.props.auth.user.name},</div>
								<br />
								<br />
								Pred Vama se nalazi prvi deo testa sposobnosti. Ovom testu možete pristupiti samo jednom.
								<br />
								<br />
								Ukoliko se iz nekih nepredviđenih razloga (zatvaranje stranice, izlazak iz pretraživača, osvežavanje stranice testa) 
								izlogujete sa testa, javite se na e-mail adresu: {this.props.auth.user.company === "Group" ? "tanja.petrovic@galeb.com" : "jovana.markovic@galeb.com"}.
								<br />
								<br />
								Svaki zadatak u prvom delu testa sastoji se od 5 slika, pri čemu je Vaš zadatak da od 4 slike sa desne
								<br />
								strane odaberete jednu koja je identična kao slika na levoj strani.
								<br />
								Vremensko ograničenje je 4 minuta, nakon čega će se Vaši odgovori automatski sačuvati, bez obzira da li ste odgovorili na sva pitanja.
								<br /><br />
								<div style={centerText}>Primer: Označen je broj 2 zato što je slika broj sa desne strane identična kao slika sa leve strane</div>
								<br />
								<div style={centerText}><img src={image1} alt='imageExample' style={{width:'100%'}}/></div>
								<br /><br />
								<div style={centerText}>Zadaci za vežbu. Pre nego što pređete na test, uradite dva zadatka za vežbu.</div>
								<div style={centerText}><img src={image2} alt='imageExample' style={{width:'100%'}}/></div>
								<div style={centerText}>
									<table style={{ width: '596px' }}>
										<tr>
											<td style={{ width: '140px' }}></td>
											<td style={{ width: '115px', textAlign: 'center' }}>
												<div className="form-check">
													<label style={{ 'fontSize': '15px' }}>
														<input
															onChange={this.onChange}
															type="radio"
															name="P1"
															value="1"
															className="form-check-input"
														/> 1 </label>
												</div>
											</td>
											<td style={{ width: '115px', textAlign: 'center' }}>
												<div className="form-check">
													<label style={{ 'fontSize': '15px' }}>
														<input
															onChange={this.onChange}
															type="radio"
															name="P1"
															value="2"
															className="form-check-input"
														/> 2 </label>
												</div>
											</td>
											<td style={{ width: '115px', textAlign: 'center' }}>
												<div className="form-check">
													<label style={{ 'fontSize': '15px' }}>
														<input
															onChange={this.onChange}
															type="radio"
															name="P1"
															value="3"
															className="form-check-input"
														/> 3 </label>
												</div>
											</td>
											<td style={{ width: '115px', textAlign: 'center' }}>
												<div className="form-check">
													<label style={{ 'fontSize': '15px' }}>
														<input
															onChange={this.onChange}
															type="radio"
															name="P1"
															value="4"
															className="form-check-input"
														/> 4 </label>
												</div>
											</td>
										</tr>
									</table>
								</div>
								<div style={centerText}><img src={image3} alt='imageExample' style={{width:'100%'}}/></div>
								<div style={centerText}>
									<table style={{ width: '596px' }}>
										<tr>
											<td style={{ width: '140px' }}></td>
											<td style={{ width: '115px', textAlign: 'center' }}>
												<div className="form-check">
													<label style={{ 'fontSize': '15px' }}>
														<input
															onChange={this.onChange}
															type="radio"
															name="P2"
															value="1"
															className="form-check-input"
														/> 1 </label>
												</div>
											</td>
											<td style={{ width: '115px', textAlign: 'center' }}>
												<div className="form-check">
													<label style={{ 'fontSize': '15px' }}>
														<input
															onChange={this.onChange}
															type="radio"
															name="P2"
															value="2"
															className="form-check-input"
														/> 2 </label>
												</div>
											</td>
											<td style={{ width: '115px', textAlign: 'center' }}>
												<div className="form-check">
													<label style={{ 'fontSize': '15px' }}>
														<input
															onChange={this.onChange}
															type="radio"
															name="P2"
															value="3"
															className="form-check-input"
														/> 3 </label>
												</div>
											</td>
											<td style={{ width: '115px', textAlign: 'center' }}>
												<div className="form-check">
													<label style={{ 'fontSize': '15px' }}>
														<input
															onChange={this.onChange}
															type="radio"
															name="P2"
															value="4"
															className="form-check-input"
														/> 4 </label>
												</div>
											</td>
										</tr>
									</table>
								</div>
								<br /><br />
								<div style={centerText}><Link to="/intTestOne" className="btn btn-info btn-fill col-md-2" >Pređi na test</Link></div>
							</div>
						</div>
					</div>
				</div>
			</div >
		)
	}
}

const mapStateToProps = state => ({
	auth: state.auth,
});

export default connect(
	mapStateToProps,
)(introIntTestOne);